// Stripe configuration and price IDs
// These can be overridden via environment variables

export const STRIPE_PRICES = {
  PREMIUM_MONTHLY: import.meta.env.VITE_STRIPE_PRICE_MONTHLY || 'price_1SpiSPPK9rHC3yaoZjnQuaDN',
  PREMIUM_6MONTH: import.meta.env.VITE_STRIPE_PRICE_6MONTH || 'price_1Sq6yFPK9rHC3yao46QAmAIh',
  PREMIUM_1YEAR: import.meta.env.VITE_STRIPE_PRICE_1YEAR || 'price_1Sq743PK9rHC3yaoAz6oIiNI',
} as const;

export const STRIPE_PRODUCTS = {
  PREMIUM_MONTHLY: 'prod_TnJ4s78pgwuqm1',
  PREMIUM_6MONTH: 'prod_TniPE2IWFIHSdF',
  PREMIUM_1YEAR: 'prod_TniVufP5p9aPle',
} as const;

// Helper to identify yearly subscription
export const is1YearPrice = (priceId: string): boolean =>
  priceId === STRIPE_PRICES.PREMIUM_1YEAR;

export const is6MonthPrice = (priceId: string): boolean =>
  priceId === STRIPE_PRICES.PREMIUM_6MONTH;

export type StripePriceId = typeof STRIPE_PRICES[keyof typeof STRIPE_PRICES];
export type StripeProductId = typeof STRIPE_PRODUCTS[keyof typeof STRIPE_PRODUCTS];
